// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-area textarea[data-v-ded0c4ce]{display:block;width:100%;resize:none}`, "",{"version":3,"sources":["webpack://./src/components/AppointmentConfigModal/TextArea.vue"],"names":[],"mappings":"AAGC,qCACC,aAAA,CACA,UAAA,CACA,WAAA","sourcesContent":[".text-area textarea{display:block;width:100%;resize:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
